module.exports = __webpack_public_path__ + "79c78bb4160e3ff2676578ecd873fa8a.png";